module.exports = __webpack_public_path__ + "img/jacket1.9505cb94.svg";